const SUCCESSFUL_STUDENT_DATA_KEYS = new Set([
  "targetStudent",
  "targetStudentDisabled",
]);

const LEGACY_SUCCESSFUL_STUDENT_CATEGORY_IDS = new Set([9, 10]);

export const isSuccessfulStudentCategory = (category) => {
  if (category?.additional) {
    return SUCCESSFUL_STUDENT_DATA_KEYS.has(category.additional);
  }

  return LEGACY_SUCCESSFUL_STUDENT_CATEGORY_IDS.has(Number(category?.id));
};

export const isSchoolStudentCategory = (category) =>
  Number(category?.id) === 7 || isSuccessfulStudentCategory(category);

export const canReuseApplicantAmkaForSuccessfulStudent = ({
  applicantAmka,
  childAmka,
  category,
  applicantIsOrphanInSeasonWhitelist,
}) => {
  const normalizedApplicantAmka = String(applicantAmka || "").trim();
  const normalizedChildAmka = String(childAmka || "").trim();

  return (
    applicantIsOrphanInSeasonWhitelist === true &&
    normalizedApplicantAmka === normalizedChildAmka &&
    isSuccessfulStudentCategory(category)
  );
};
